import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: '',
  loading: false,
  message: '',
  navCollapsed: true,
  width: window.innerWidth,
  initURL: '/maddeler',
  offerID: 1,
  offerShouldTableScroll: false,
  offerListURL: null,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state) => {
      state.loading = false;
      state.error = '';
    },
    fetchError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    locationChange: (state, action) => {
      state.pathname = action.payload.location.pathname;
      state.navCollapsed = false;
    },
    windowWidth: (state, action) => {
      state.width = action.payload;
    },
    toggleCollapsedNav: (state, action) => {
      state.navCollapsed = action.payload;
    },
    showMessage: (state, action) => {
      state.error = '';
      state.message = action.payload;
      state.loading = false;
    },
    hideMessage: (state) => {
      state.loading = false;
      state.error = '';
      state.message = '';
    },
    setOfferTable: (state, action) => {
      state.offerID = action.payload.offerID;
      state.offerListURL = action.payload.offerListURL ?? null;
    },
    setShouldScroll: (state, action) => {
      state.offerShouldTableScroll = action.payload;
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchError,
  showMessage,
  hideMessage,
  setOfferTable,
  setShouldScroll,
  windowWidth,
  toggleCollapsedNav,
} = commonSlice.actions;

export default commonSlice.reducer;
